export default "__VITE_ASSET__o3pnpU60__"